<template>
  <div class="postcode-lookup">
    <label>{{title}}</label>

    <div class="postcode-lookup__address" v-show="showFullAddress">
      <Input
        :name="0"
        label="Address Line 1"
        placeholder="Address Line 1"
        :required="true"
        :title="titles.lettersAndNumbers"
        :vuexPath="[...vuexPath, 'fields', 'addressLines']"
        @change="unsetAddressVerified"
      />
      <Input
        :name="1"
        label="Address Line 2"
        placeholder="Address Line 2"
        :pattern="patterns.lettersAndNumbers"
        :title="titles.lettersAndNumbers"
        :vuexPath="[...vuexPath, 'fields', 'addressLines']"
        @change="unsetAddressVerified"
      />
      <Input
        name="town"
        label="Town / City"
        placeholder="Town / City"
        :required="true"
        :pattern="patterns.lettersAndNumbers"
        :title="titles.lettersAndNumbers"
        :vuexPath="vuexPath"
        @change="unsetAddressVerified"
      />
      <Input
        v-show="hasCounty"
        name="county"
        label="County"
        placeholder="County"
        :required="!hasCounty"
        :pattern="patterns.lettersAndNumbers"
        :title="titles.lettersAndNumbers"
        :vuexPath="vuexPath"
        @change="unsetAddressVerified"
      />

      <div class="country-wrapper">
        <Input
          name="country"
          label="Country"
          placeholder="Country"
          :required="true"
          :title="titles.lettersAndNumbers"
          :vuexPath="vuexPath"
          :value="title"
          :options="countryOptions"
          @change="unsetAddressVerified"
        />
        <slot></slot>
      </div>
    </div>

    <div class="postcode-lookup__search">
      <div class="postcode-lookup__postcode">
        <Input
          name="postCode"
          label="Postcode"
          placeholder="Postcode"
          :required="true"
          :pattern="patterns.postcode"
          :title="titles.postcode"
          :vuexPath="vuexPath"
          @change="unsetAddressVerified"
        />
      </div>

      <button type="button"
              class="btn postcode-lookup__button"
              :disabled="!address.postCode || !address.postCode.length"
              aria-label="Lookup address"
              title="Lookup address"
              @click="search">
        Lookup
      </button>

      <ul class="postcode-lookup__results" v-if="addresses.length">
        <li v-for="address in addresses" :key="address.id">
          <button
            type="button"
            class="postcode-lookup__result"
            @click="setAddress(address.id)"
          >{{address.description}}</button>
        </li>
      </ul>
    </div>

    <div v-if="noResults" class="postcode-lookup__error error-message">
      <div class="error-message__icon"></div>
      <div class="error-message__text">
        <p>No results found. Please check the postcode or enter the address manually.</p>
      </div>
    </div>

    <button
      v-if="!showFullAddress"
      type="button"
      class="link"
      @click="manualInput = true"
    >Enter address manually</button>

    <Input name="addressVerified" type="hidden" :vuexPath="vuexPath" ref="addressVerified" />
  </div>
</template>

<script>
import axios from 'axios';
import Input from './Input.vue';
import { objectHasValues } from '@/utils';
import ValidationMixin from '@/vue/components/Form/validationMixin';
import {Brand} from './../../../brand.js';
import { mapState } from 'vuex';

export default {
  mixins: [ValidationMixin],

  components: {
    Input
  },

  props: {
    vuexPath: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'Address'
    },
    brandName: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      Brand,
      manualInput: false,
      noResults: false,
      addresses: [],
      hasCounty: true,
      countryOptions: []
    };
  },

  computed: {
    address: {
      get() {
        return this.$store.getters.formDataFlat(this.vuexPath);
      },
      set(address) {
        this.$store.commit('setFieldValuesFromFlat', {
          flat: address,
          vuexPath: this.vuexPath
        });
      }
    },

    showFullAddress() {
      return (
        this.manualInput || this.$store.getters.formHasBeenSubmitted(this.vuexPath) || objectHasValues(this.address, true, ['postCode'])
      );
    }
  },    

  watch: {
    /** empty the autocomplete addresses whenever the address changes */
    address: {
      handler() {
        this.addresses = [];
      },
      deep: true
    }
  },

  mounted() {
    // close the address selector when clicking anywhere on the page
    document.body.addEventListener('click', () => {
      this.addresses = [];
    });

    axios.get('/umbraco/api/address/countries', {})
    .then(response => {
      this.countryOptions = response.data;
    })
  },

  methods: {
    search() {
      axios
        .get('/umbraco/api/address/postcodelookup', {
          params: {
            postcode: this.address.postCode
          }
        })
        .then(response => {
          this.addresses = response.data;

          if (this.addresses.length) {
            this.noResults = false;
            this.$emit('address-updated');
          } else {
            this.noResults = true;
          }
        });
    },

    setAddress(id) {
      axios
        .get('/umbraco/api/address/address', {
          params: {
            id
          }
        })
        .then(response => {
          this.address = {
            ...response.data,
            addressLines: [
              response.data.addressLines[0],
              response.data.addressLines[1]
            ],
            addressVerified: true
          };

          this.hasCounty = response.data.county == "" ? false : true;
          this.$emit('address-updated');
        });
    },

    unsetAddressVerified() {
      this.$store.commit('setFieldValue', {
        name: 'addressVerified',
        value: false,
        target: this.$refs.addressVerified,
        vuexPath: this.vuexPath
      });
    }
  }
};
</script>
